import { useEffect, useState } from "react";
import axios from "axios";
import { NGROK } from "../APIs";
import useUserStore from "../services/userStore";
import { apiClient } from "../utils/apiClient";


export interface Tenant {
  tenantName: string;
  domainName: string;
  email: string;
  numberOfComputers: number;
  numberOfUsers: number;
  mode: string;
  apiKey: {
    key: string;
    expiredAt: string;
  };
}

export function useTenants() {
  const { role, email, userId } = useUserStore((state) => state.user);

  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email) return;
    const fetchTenantsData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${NGROK}/api/get-all-domains?email=${email}`);

        setTenants(response.data || []);

      } catch (error) {
        console.error(error);
        setTenants([]);
      } finally {
        setLoading(false);
      }
    };
    fetchTenantsData();
  }, [email]);

  return { tenants, loading };
}
